import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import PiWriterLogTableService from '../service/PiWriterLogTableService';
import ShowChartButton from '../component/ShowChartButton';

const config = {
	key: 'piWriterLogTable',
	topic: 'piWriterLog',
	service: PiWriterLogTableService,
	editFormState: item => `/pi-writer-log/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	rowButtonList: [/*{ key: 'showChart', component: ShowChartButton }*/],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}piWriterLogTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		},
		{
			key: 'tableName'
		},
		{
			key: 'description'
		}
	]
};

function PiWriterLogTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('piWriterLogTable', reducer('piWriterLogTable'))(PiWriterLogTable);
